export default "__VITE_ASSET__e6371412__"